import React from 'react';
import { Row, Typography, Col, Avatar } from 'antd';
import { Images } from 'config/assets';

const { Text } = Typography;

const PostProductShortInfo = ({
  postProductItem,
  validationResult,
  targetType = ['walmart', 'krogger'][0],
}) => {
  return (
    <Row style={{ marginTop: 6 }}>
      <Col>
        <div style={{ width: 80 }}>
          <Avatar
            className='post-to-walmart-krogger__product-image'
            shape='square'
            src={postProductItem?.thumbnail || Images.RIVIR_LOGO_DEFAULT}
          />
        </div>
      </Col>
      <Col style={{ flex: 1, padding: 6, overflow: 'hidden' }}>
        <div>
          <Text strong>{`GTIN - ${postProductItem?.gtin}`}</Text>
        </div>
        <div>
          <Text strong ellipsis>
            {postProductItem?.productName
              ? `Product Name - ${postProductItem?.productName}`
              : 'N/A'}
          </Text>
        </div>
        {validationResult && (
          <div>
            <Text strong ellipsis>
              {targetType === 'walmart'
                ? `Walmart Product Type - ${validationResult?.walmartProductType}`
                : `Kroger Product Type - ${validationResult?.krogerProductType}`}
            </Text>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default PostProductShortInfo;
